import { render, staticRenderFns } from "./commissionAgreementApprova.vue?vue&type=template&id=511ec4ca&scoped=true&"
import script from "./commissionAgreementApprova.vue?vue&type=script&lang=js&"
export * from "./commissionAgreementApprova.vue?vue&type=script&lang=js&"
import style0 from "./commissionAgreementApprova.vue?vue&type=style&index=0&id=511ec4ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511ec4ca",
  null
  
)

export default component.exports